import axios from "axios";
import { useQuery } from "react-query";

export type HeritageStoredCredentials = {
  hasCredentials: boolean;
  customerAccountId: string | null;
  apiKeyLast4: string | null;
};

async function fetchHeritageStoredCredentials(): Promise<HeritageStoredCredentials> {
  const response = await axios.get<HeritageStoredCredentials>(
    `${process.env.REACT_APP_SERVER_URL}/api/v1/company/heritage/stored-credentials`
  );
  return response.data;
}

export function useHeritageStoredCredentials(enabled: boolean) {
  return useQuery<HeritageStoredCredentials>(
    ["heritage-stored-credentials"],
    fetchHeritageStoredCredentials,
    {
      enabled,
      staleTime: 1000 * 60 * 2,
      refetchOnWindowFocus: false,
    }
  );
}

export function formatMaskedApiKeyHint(apiKeyLast4: string | null | undefined): string {
  if (!apiKeyLast4) return "—";
  return `••••••••••••${apiKeyLast4}`;
}
